import { useState, useEffect, FC, RefObject } from 'react'
import { useDispatch } from 'react-redux'

import { openModal } from 'store/actions/modals'
import { isMobile } from 'services/Utilities'
import useClickOutside from 'components/Hooks/useClickOutside'
import { Button, ButtonGroup } from 'ui'
import { ClearButton } from '.'
import { MFilters } from 'types/filterTypes'

type FilterDropDownProps = {
  buttonClass?: string
  buttonContent: JSX.Element
  splitButton: 'clearButton' | JSX.Element | null
  type?: string
  contentName: MFilters.ContentTypes
  dropDownType: 'SavedPresets' | 'HeroFilter' | 'FiltersButton' | 'DateFilterButton'
  count?: number
  withTime?: boolean
  rangeStart?: string
  filters?: string[]
  name?: string
  children: (props: { closeDropdown: () => void; isOpen?: boolean }) => JSX.Element
}

const FilterDropDown: FC<FilterDropDownProps> = ({
  children,
  buttonClass,
  buttonContent,
  splitButton,
  type,
  contentName,
  dropDownType,
  filters,
  count,
  rangeStart,
  withTime,
  name
}) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const domNodeRef = useClickOutside(() => {
    setIsOpen(false)
  }) as RefObject<HTMLDivElement> | null
  //Function to close the dropDown when pressing escape key
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsOpen(false)
    }
    //Adding the event listener
    window.addEventListener('keydown', handleKeyDown)
    //Removing the event listener
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return (
    <>
      <div className="position-relative" ref={domNodeRef}>
        <ButtonGroup>
          <Button
            color="secondary"
            outlined
            size="small"
            className={buttonClass ? buttonClass : `${!count && !rangeStart ? 'mr-1' : ''}`}
            style={{ minHeight: '31px' }}
            onClick={() =>
              !isMobile()
                ? setIsOpen(state => !state)
                : dispatch(openModal(`DropDown${dropDownType}Modal`, { filters, contentName, withTime, name, isOpen: true }))
            }
            data-cy={'FilterDropDownButton'}
          >
            {buttonContent}
          </Button>
          {splitButton === 'clearButton' && count ? <ClearButton type={type} contentName={contentName} filters={filters} /> : null}
          {splitButton !== 'clearButton' ? splitButton : null}
        </ButtonGroup>

        {isOpen ? (
          <div className=" form-control p-0 position-absolute mt-1" style={{ zIndex: '20', width: 'fit-content', height: 'fit-content' }}>
            {/* children being a function allows formik style passing of functions to children, like the ability to close the dropdown */}
            {children({ closeDropdown: () => setIsOpen(false), isOpen })}
          </div>
        ) : null}
      </div>
    </>
  )
}

export default FilterDropDown
